/* eslint-disable no-useless-rename */
/* eslint-disable jsx-a11y/anchor-is-valid */

import {useEffect, useMemo, useRef, useState} from 'react'
import clsx from 'clsx'
import {useDispatch, useSelector} from 'react-redux'

//components
// import WSButton from '_metronic/helpers/components/WSButton/WSButton'

//conatants

//css
import './QuickMessage.scss'
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

import {useLocation} from 'react-router-dom'

import Select, {MenuListProps, components} from 'react-select'
///////////////working/////////////

import {startLoadding, stopLoading} from '../../../../app/Redux/FrontEnd/Loading/LoadingSlice'
import {fetchAsyncQuickMms} from '../../../../app/Redux/FrontEnd/QuickMessageSlice/quickMmsSlice'
import {fetchAsyncQuickSms} from '../../../../app/Redux/FrontEnd/QuickMessageSlice/QuickSmsSlice'
import WSButton from '../../../helpers/components/WSButton/WSButton'
import MessageBoxV2 from '../../../../app/Components/MessageBoxV2'
import GiphyPopup from '../../../../app/pages/Common/GiphyPopup/GiphyPopup'
import {Form, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap'

import {KTSVG, timeZone, toAbsoluteUrl, useDebounce} from '../../../helpers'
import React from 'react'
import {
  getDedicatedNumber,
  getDedicatedNumberList,
} from '../../../../app/pages/UserPages/accounts/DedicatedNumber/DedicatedNumberSlice/DedicatedNumberSlice'
import {
  isMobileValidate,
  isNumberOnly,
  numberWithSymbol,
} from '../../../../app/Utils/_helpers/ValidationSchema'
import {getCampaignReplies} from '../../../../app/pages/UserPages/reports-analytics/reportSlices/reportAnalytics'
import {
  GetAllData as GetAllCustomeData,
  getCustomNunberList,
} from '../../../../app/pages/UserPages/accounts/CustomNumber/CustomNumberSlice/CustomNumberSlice'
import {
  GetAllData,
  getBusinessName,
} from '../../../../app/pages/UserPages/accounts/BusinessName/BusinessNameSlice/BusinessSlice'
import moment from 'moment'
import momentTz from 'moment-timezone'
import BulkMessageBox from '../../../../app/pages/UserPages/new-message/WizardStep/Components/BulkMessageBox'
import CreatableSelect from 'react-select/creatable'
import {
  GetContactSearch,
  OptionList,
  QuickMsgDraftData,
} from '../../../../app/Redux/AdminPanel/QuickMessageSlice'
import {
  CreateNewTemplate,
  EditTemplate,
} from '../../../../app/pages/UserPages/MyTemplate/CreateScratch/CreateScratchSlices/CreateScratchSlices'
import {
  base64ToFile,
  DEFAULT_REPLY_STOP_OUT_COUNT,
  fileToBase64,
  findMatchingArrayName,
  isEmpty,
  processData,
  replaceMessageWith,
  validateArrayPhones,
  validateArrayPhonesRegion,
} from '../../../../app/Utils/_helpers'
import {Elements} from '@stripe/react-stripe-js'
import VirtualNumbersModal from '../../../../app/pages/UserPages/accounts/DedicatedNumber/VirtualNumbersModal'
import CreateBusinessNamePopup from '../../../../app/pages/UserPages/accounts/BusinessName/Modal/CreateBusinessNamePopup'
import CreateCustomNumber from '../../../../app/pages/UserPages/accounts/CustomNumber/Modal/CreateCutomNumber'

import {getReviewData} from '../../../../app/pages/UserPages/new-message/BulkMessageSlice/BulkMessageSlice'
import {GetAllData as GetAllOptoutData} from '../../../../app/pages/UserPages/Opt_out/OptoutSlice/OptoutListSlice'
import {GeneralDataOFLoginUser} from '../../../../app/Utils/Auth'
import PurchasePopup from '../../../../app/Components/PurchasePopup'
import {FirstTimeApprovalData} from '../../../../app/Components/PopupSlice/popupSlice'
import StripeJSProvider from '../../../../app/Utils/StripeJSProvider'
import {
  GLOBAL_SETTINGS_TYPE,
  QUICK_CONTACT_LIMIT,
  REGION,
} from '../../../../app/Utils/Constant/ConstantForWebsite'
import QMContactListPopup from '../../../../app/Components/QMContactListPopup'
import QMContactSegmentListPopup from '../../../../app/Components/QMConctactSegmentListPopup'
import {globalSettingsTypes} from '../../../../app/Utils/Constant/status'
import {toast} from 'react-toastify'
import DatePicker from 'react-datepicker'
import {useTimezone} from '../../../../app/hooks/useTimezone'
import {
  fetchAsyncUserDetails,
  getAllUserDetails,
  getDefaultOptOutUrl,
  getDefaultOptOutUrlCount,
  getDefaultRegion,
  getDefaultShortUrl,
  getIsDefaultRegion,
} from '../../../../app/pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import VCardPreview from '../../../../app/Components/VCardPreview'
import {useQuickMessageMutation} from '../../../../services/cellcast.v3'
import {toUpper} from 'lodash'
import {ENV} from '../../../../app/Utils/_helpers/EnvHelper'
import _ from 'lodash'
import {useNewMessage} from '../../../../app/pages/UserPages/new-message/useNewMessage'
import {ChevronUp, ChevronDown} from 'react-bootstrap-icons'
import {useOutsideAlerter} from '../../../../app/hooks/useOutsideAlerter'

export const initialData = {
  camp_type: 'sms',
  sender: '#SharedNum#',
  contacts: [],
  subject: '',
  media: '',
  message: '',
  optout: false,
  optoutId: '',
  replyStopToOptOut: true,
  alphaId: '',
  gif: '',
  longUrl: [],
  landingPage: false,
  landingPageId: '',
  senderType: '',
}

const MAX_FILE_SIZE = 1572864 //1048576;

const QuickMessageDrawerInner = ({
  valid,
  setValid,
  show,
  handleClose,
  contacts,
  CustomReplyReport,
  setCustomReplyReport = () => {},
}: any) => {
  const dispatch = useDispatch()
  const param: any = useLocation()
  const [name, setName] = useState(false)
  const [customNumber, setCustomNumber] = useState(false)
  const [isRefresh, setIsRefresh] = useState(false)
  const mediaInput: any = useRef(null)
  const [visible, setVisible] = useState<any>(false)
  const mediaInputVideo: any = useRef(null)

  const userDetail: any = useSelector(getAllUserDetails)
  const {getUserTimezoneNow, timezoneLabel, userTimezone} = useTimezone()
  const userTimezoneNow = getUserTimezoneNow()
  const optOutBaseUrl = useSelector(getDefaultOptOutUrl)
  const defaultShortUrl = useSelector(getDefaultShortUrl)
  const defaultOptOutUrlCount = useSelector(getDefaultOptOutUrlCount)
  const ShortLinkList = useSelector((state: any) => state?.ShortLink?.allTrackingLinks)

  ////////////////////////////////////////////////////////////////USE SELECTOR//////////////////////
  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData)
  const quickmsg = useSelector((state: any) => state?.quickMsg?.QuickMsg)
  const quickDraftData = useSelector((state: any) => state?.quickMsg?.QuickMsgDraftData)
  const virtualNumber = useSelector(getDedicatedNumber)
  const list = useSelector(OptionList)
  const CustomNumberList = useSelector(getCustomNunberList)
  const bussinessName = useSelector(getBusinessName)
  const isAdmin = localStorage.getItem('isAdmin')
  const credits = useSelector((state: any) => state?.userDetails?.userDetails?.data)
  const ReviewData = useSelector(getReviewData)
  const userData: any = GeneralDataOFLoginUser()?.globalSettingData?.[0]?.value
  const OptOutDefault = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)
  const optoutList = useSelector((state: any) => {
    const userGlobalSettings = state?.userDetails?.userDetails?.data?.user?.globalSetting
    let list = state?.optoutList?.optoutList?.data?.items || []

    if (quickDraftData?.camp_type === 'sms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    if (quickDraftData?.camp_type === 'mms') {
      const isDisableReplyByGlobalOption = userGlobalSettings?.includes(
        GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
      )
      list = isDisableReplyByGlobalOption ? list : []
    }

    return list
  })

  const rawOptoutItems = useSelector((state: any) => state?.optoutList?.optoutList?.data?.items)

  const globalSettings = useSelector(
    (state: any) => state?.userDetails?.userDetails?.data?.user?.globalSetting
  )

  const [isShowCredit, setIsShowCredit] = useState(true)
  useEffect(() => {
    if (userDetail && userDetail.subClientAccountId && userDetail.subClientAccountId !== '') {
      if (userDetail._id !== userDetail.ownerId) {
        setIsShowCredit(false)
      }
    }
  }, [userDetail])
  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const userRegion = useSelector(getDefaultRegion)

  const [postUsQM, {isLoading: postUsQMLoading}] = useQuickMessageMutation()

  /////////////////////////////////USE STATE/////////////////
  const [purchasePopupModal, setPurchasePopupModal] = useState<any>(false)
  const [templateNameModel, setTemplateNameModel] = useState(false)
  const [templateName, setTemplateName] = useState('')
  const [giphyShow, setGiphyShow] = useState(false)
  const [quickSms, setQuickSms] = useState(true)
  const [success, setSuccess] = useState(false)
  const [preview, setPreview] = useState(false)
  const [searchName, setSearchName] = useState('')
  const [contactListModel, setContactListModel] = useState<any>(false)
  const [contactSegmentListModel, setContactSegmentListModel] = useState<any>(false)
  const [isForward, setIsForward] = useState(false)
  const [isLater, setIsLater] = useState(false)
  const [laterDate, setLaterDate] = useState(userTimezoneNow)
  const [isAddContactOpen, setIsAddContactOpen] = useState(false)

  const addContactRef = useRef(null)
  useOutsideAlerter(addContactRef, () => {
    setIsAddContactOpen(false)
  })

  const [purchaseModelData, setPurchaseModelData] = useState({
    type: '',
    purchaseCredit: 0,
    minimum: 0,
  })

  const [options, setOptions] = useState({
    webLink: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    customLanding: [
      {value: 'https/', label: 'link2'},
      {value: 'https', label: 'link3'},
    ],
    optOut: [
      {value: "Reply 'Stop' to opt-out ", label: 'Reply Stop'},
      {value: 'STOP:{stoptxt.cc/}', label: 'custom survey'},
    ],
  })

  const [sendData, setSendData] = useState<any>({
    camp_type: 'sms',
    sender: [REGION.UK].includes(userRegion) ? '' : '#SharedNum#',
    contacts: [],
    subject: '',
    media: '',
    message: '',
    optout: false,
    optoutId: '',
    alphaId: '',
    gif: '',
    longUrl: [],
    replyStopToOptOut: true,
    replyStopToOptOutSecond: false,
    senderType: '',
    forwardReplyTo: '',
    landingPage: false,
    landingPageId: '',
  })
  const [error, setError] = useState<any>({})

  useEffect(() => {
    if (show) {
      dispatch(fetchAsyncUserDetails())
      // Fetch optout data if not already loaded (e.g., user bypassed dashboard via redirect URL)
      if (!rawOptoutItems?.length) {
        dispatch(GetAllOptoutData())
      }
      setPreview(show)
    } else {
      setTimeout(() => {
        setPreview(show)
      }, 600)
    }
  }, [show])

  useEffect(() => {
    if (!optoutList?.length) {
      setSendData((prev: any) => ({
        ...prev,
        replyStopToOptOut: false,
        optout: false,
        optoutId: '',
      }))
    } else {
      setSendData((prev: any) => {
        if (!prev.optout && !prev.replyStopToOptOut) {
          if (['businessName', 'customNumber'].includes(prev.senderType)) {
            const defaultOptoutId = OptOutDefault?.defaultOptoutId ?? ''
            const defaultOptout = optoutList?.find((key: any) => key._id === defaultOptoutId)
            return {
              ...prev,
              replyStopToOptOut: false,
              optout: true,
              optoutId: (defaultOptout?._id ?? optoutList?.at(0)?._id) ?? '',
              optoutLabel: (defaultOptout?.title ?? optoutList?.at(0)?.title) ?? '',
            }
          }
          return {
            ...prev,
            replyStopToOptOut: true,
          }
        }
        return prev
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optoutList?.length, OptOutDefault?.defaultOptoutId])

  const hasCustomPriceSetting =
    globalSettings && globalSettings?.includes(globalSettingsTypes.SEND_WITH_CUSTOM_PRICE)
  const isSenderBusinessNameOrCustomNumber =
    sendData?.senderType === 'businessName' || sendData?.senderType === 'customNumber'

  const isCustomPriceOrAlphaId = hasCustomPriceSetting
    ? isSenderBusinessNameOrCustomNumber
    : !globalSettings && isSenderBusinessNameOrCustomNumber

  useEffect(() => {
    let tempSendData: any = {}
    let dedicatedNumber =
      virtualNumber && Array.isArray(virtualNumber) ? virtualNumber : [{value: '', label: 'Select'}]
    let customNumber =
      CustomNumberList && Array.isArray(CustomNumberList)
        ? CustomNumberList
        : [{value: '', label: 'Select'}]
    let businessNameList =
      bussinessName && Array.isArray(bussinessName) ? bussinessName : [{value: '', label: 'Select'}]

    if (sendData.camp_type === 'mms') {
      dedicatedNumber = dedicatedNumber?.filter((el: any) => el?.type === 'MMS')
    }

    // Helper function to get default number for subclient users
    const getDefaultNumber = () => {
      const isSubClient =
        userDetail?.subClientAccountId && userDetail._id !== userDetail.subClientAccountId
      const allNumbers = [...dedicatedNumber, ...customNumber, ...businessNameList]

      if (isSubClient) {
        // For subclient users, look for subClientDefaults
        const defaultSubClientNumber = allNumbers.find(
          (key: any) => key?.subClientDefaults && key.subClientDefaults[userDetail._id] === true
        )
        if (defaultSubClientNumber || (userDetail.ownerId && userDetail._id !== userDetail.ownerId)) {
          return defaultSubClientNumber
        }
      } 
      // For owner users, use existing isDefault logic
      return allNumbers.find((key: any) => key?.isDefault)
    }

    const DefaultNumber = getDefaultNumber()

    const checkValue = DefaultNumber?.audNumber
      ? DefaultNumber?.audNumber
      : DefaultNumber?.businessname
      ? DefaultNumber?.businessname
      : DefaultNumber?.number
      ? DefaultNumber?.number
      : quickDraftData?.sender

    let mediaData = quickDraftData?.media ?? ''
    if (isEmpty(sendData?.media) && typeof sendData?.media == 'string') {
      if (mediaData?.startsWith('data:')) {
        mediaData = base64ToFile(mediaData)
      }
    }

    setQuickSms(quickDraftData?.camp_type != 'mms')
    let senderNumber
    if (!quickDraftData?.senderType) {
      senderNumber = checkValue
    } else if (quickDraftData?.senderType == '#SharedNum#') {
      senderNumber = '#SharedNum#'
    } else {
      senderNumber = checkValue
    }

    const senderType = findMatchingArrayName(checkValue, senderTypeData)
    tempSendData = {
      ...sendData,
      ...quickDraftData,
      sender: senderNumber,
      media: mediaData,
      senderType,
    }

    // Handle when disable reply stop out and opt out link
    if (!optoutList?.length) {
      tempSendData.replyStopToOptOut = false
      tempSendData.replyStopToOptOutSecond = false
      tempSendData.optout = false
      tempSendData.optoutId = ''
    }

    if (['businessName', 'customNumber'].includes(senderType) && optoutList?.length > 0) {
      const defaultOptoutId = OptOutDefault?.defaultOptoutId ?? ''
      const defaultOptout = optoutList?.find((key: any) => key._id === defaultOptoutId)

      tempSendData.replyStopToOptOut = false
      tempSendData.replyStopToOptOutSecond = false

      tempSendData.optout = true
      tempSendData.optoutId = defaultOptout?._id ?? optoutList?.at(0)._id
      tempSendData.optoutLabel = defaultOptout?.title ?? optoutList?.at(0).title
    }

    if (quickmsg === 'profile') {
      tempSendData = {...tempSendData, contacts: [ProfileDetatileState?.user?.mobile]}
    } else if (quickmsg === 'whitelabel-profile') {
      tempSendData = {...tempSendData, contacts: [ProfileDetatileState?.items?.[0]?.user?.mobile]}
    } else {
      tempSendData = {...tempSendData, contacts: quickDraftData?.contacts}
      setSuccess(false)
    }
    if (CustomReplyReport?.number?.length > 0) {
      tempSendData = {
        ...tempSendData,
        contacts: [{value: CustomReplyReport?.number, label: CustomReplyReport?.number}],
      }
    }
    if (contacts?.length > 0) {
      tempSendData = {...tempSendData, contacts: contacts}
    }

    if ([REGION.UK].includes(userRegion)) {
      if (tempSendData.sender === '#SharedNum#') {
        tempSendData.sender = ''
      }
    }

    setSendData(tempSendData)
  }, [
    virtualNumber,
    CustomNumberList,
    bussinessName,
    quickmsg,
    contacts,
    CustomReplyReport?.number,
    show,
  ])

  const validationOfquickmsg = (value: any) => {
    const err: any = {}

    if (value?.sender === '' && value?.senderType === '') {
      err.sender = 'Please select Sender'
    }
    if (value?.contacts?.length === 0) {
      err.contacts = 'Please add contacts'
    }

    if (quickSms === false) {
      if (value?.media === '' && value?.gif === '') {
        err.media = 'Please upload a media file.'
      }
    }

    if (value?.message === '') {
      err.message = 'Please provide content of Message'
    }

    const shortUrl = ENV().REACT_APP_SHORTURL
    const landingPageUrl = `${shortUrl}/Lxxxxx`

    if (value?.message?.includes(shortUrl) && !value?.message?.includes(landingPageUrl)) {
      const text = value?.message

      const regex = new RegExp(`${shortUrl?.replace(/\./g, '\\.')}\\/([a-zA-Z0-9_-]+)`, 'gmi')
      const matches = [...text.matchAll(regex)].map((match) => match.at(1))

      const allExist = matches.every((short) =>
        value.longUrl.some((it: any) => it.shortUrl === short)
      )

      if (!allExist) {
        err.message = "Message contains tracking link but doesn't have short url been created"
      }

      const existLink = matches.every((short) =>
        ShortLinkList.some((it: any) => it.shortUrl === short)
      )

      if (!existLink) {
        err.message = "Message contains tracking link but doesn't have short url been created"
      }
    }

    setError(err)

    return err
  }

  const handleToSelectChangeValue = (e: any) => {
    // use in on blur
    if (typeof e === 'string') {
      // find in selected data
      let selectedValue = [...sendData.contacts]
      if (Array.isArray(selectedValue)) {
        const number = e
        // case 1 : number split by space
        let splitValues = number.split(' ')

        const filterCheck = splitValues.filter((el: any) => el.length < 9)
        if (filterCheck.length > 0) {
          let tmpSplitNumber = []
          let tmpCheck = ''

          for (let indexCheck = 0; indexCheck < splitValues.length; indexCheck++) {
            tmpCheck += splitValues[indexCheck]
            tmpCheck = tmpCheck.replace(/^0+/, '')
            if (tmpCheck.length >= 9) {
              tmpSplitNumber.push(tmpCheck)
              tmpCheck = ''
            }
          }

          splitValues = tmpSplitNumber
        }

        if (splitValues.length > 0 && splitValues[0].includes(',')) {
          // case 2 : try split number split by coma
          splitValues = number.split(',')
        }

        if (splitValues.length > 0) {
          // convert numbers
          const validatedNumbers = validateArrayPhonesRegion(splitValues, userRegion)
          const mapValidatedNumbers = validatedNumbers.map((it) => ({value: it, label: it}))
          setSendData({
            ...sendData,
            contacts: mapValidatedNumbers,
          })
          return
        } else {
          if (!isMobileValidate(number) || selectedValue.length > 50) {
            return
          }

          if (selectedValue.length === 0) {
            selectedValue = [
              {
                label: number,
                value: number,
              },
            ]
          } else {
            // find number
            let foundNumber = selectedValue.find((el) => el.value === number)
            if (!foundNumber) {
              selectedValue.push({
                label: number,
                value: number,
              })
            }
          }

          setSendData({
            ...sendData,
            contacts: selectedValue,
          })
        }

        return
      } else {
        if (isMobileValidate(e)) {
          setSendData({
            ...sendData,
            contacts: [{label: e, value: e}],
          })
          return
        }
      }
    }

    if (Array.isArray(e) && e.length > 0) {
      const numbers = e.flatMap((it) => it?.value)
      // case 1 : number split by space
      let splitedBySpace = numbers.flatMap((it) => it.split(' '))
      let numberArray: any[] = splitedBySpace

      const filterCheck = splitedBySpace.filter((el: any) => el.length < 9)
      if (filterCheck.length > 0) {
        let tmpSplitNumber = []
        let tmpCheck = ''

        for (let indexCheck = 0; indexCheck < splitedBySpace.length; indexCheck++) {
          tmpCheck += splitedBySpace[indexCheck]
          tmpCheck = tmpCheck.replace(/^0+/, '')
          if (tmpCheck.length >= 9) {
            tmpSplitNumber.push(tmpCheck)
            tmpCheck = ''
          }
        }
        numberArray = tmpSplitNumber
      }

      if (numberArray.length > 0 && numberArray.at(0).includes(',')) {
        // case 2 : try split number split by coma
        numberArray = numbers.flatMap((it) => it.split(','))
      }

      // convert numbers
      const validatedNumbers = validateArrayPhonesRegion(numberArray, userRegion)
      const mapValidatedNumbers = validatedNumbers.map((it) => ({value: it, label: it}))
      setSendData({
        ...sendData,
        contacts: mapValidatedNumbers,
      })
    }

    if (e?.length <= 0) {
      setSendData({
        ...sendData,
        contacts: [],
      })
    }
  }

  const fileToBase64 = (file: File | Blob): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)

      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result)
        } else {
          reject(new Error('FileReader result is not a string'))
        }
      }

      reader.onerror = () => {
        reject(reader.error || new Error('Unknown FileReader error'))
      }
    })
  }

  const landingPageUrl = `${defaultShortUrl}/Lxxxxx`
  const extractLongUrls = (message: any) => {
    if (!message || !message.includes(defaultShortUrl) || message.includes(landingPageUrl)) {
      return []
    }

    const regex = new RegExp(`${defaultShortUrl.replace(/\./g, '\\.')}\\/([a-zA-Z0-9_-]+)`, 'gmi')
    const matches = [...message.matchAll(regex)].map((match) => match.at(1))
    const uniqueMatches = new Set(matches)

    return ShortLinkList.map((it: any) => ({
      _id: it._id,
      shortUrl: it.shortUrl,
      longUrl: it.upstreamUrl,
    })).filter((it: any) => uniqueMatches.has(it.shortUrl))
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault()

    const minimumCredit = quickSms
      ? Number(userData?.MIN_PURCHASES_SMS_CERDIT ?? 20)
      : Number(userData?.MIN_PURCHASES_MMS_CERDIT ?? 20)

    const optoutCount = sendData?.optout === true ? defaultOptOutUrlCount : 0
    const replyStopToOptOutCount =
      sendData?.replyStopToOptOut === true ? DEFAULT_REPLY_STOP_OUT_COUNT : 0
    const isAlphaId =
      sendData?.senderType === 'businessName' || sendData?.senderType === 'customNumber'

    let longUrl = []

    if (
      sendData?.message?.includes(defaultShortUrl) &&
      !sendData?.message?.includes(landingPageUrl)
    ) {
      longUrl = extractLongUrls(sendData.message)
    }

    let MsgData = validationOfquickmsg(sendData)
    const contactList = sendData.contacts?.map((key: any) => (key?.value ? key?.value : key))
    if (Object.keys(MsgData).length === 0) {
      let finalData: any = {
        sender: sendData.sender,
        senderType: sendData.senderType,
        message: sendData.message,
        contacts: contactList,
        countryCode: '61',
        optout: sendData.optout,
        longUrl: longUrl,
        replyStopToOptOut: sendData.replyStopToOptOut,
        landingPage: sendData.landingPageId ? true : false,
        landingPageId: sendData.landingPageId,
      }

      if (sendData.forwardReplyTo && sendData.forwardReplyTo !== '') {
        finalData.forwardReplyTo = sendData.forwardReplyTo
      }

      if (sendData?.optoutId !== '' && sendData?.optoutId !== undefined && optoutList.length > 0) {
        finalData = {...finalData, optoutId: sendData.optoutId}
      }

      if (isLater) {
        // Convert laterDate from user's timezone to UTC for API
        const year = laterDate.getFullYear()
        const month = laterDate.getMonth()
        const day = laterDate.getDate()
        const hours = laterDate.getHours()
        const minutes = laterDate.getMinutes()
        
        // Create moment in user's timezone with the selected values, then convert to UTC
        const scheduleAtUTC = moment.tz([year, month, day, hours, minutes], userTimezone).utc().toDate()
        finalData.scheduleAt = scheduleAtUTC
      }

      // set optout false and replyStopToOptOut false when there no labels selected
      // if (!sendData.optoutLabel) {
      //   finalData = { ...finalData, optout: false, replyStopToOptOut: false }
      // }

      const isAlphaSender = ['businessName', 'customNumber'].includes(sendData?.senderType)
      const defaultOptoutForSend = optoutList?.find(
        (key: any) => key._id === OptOutDefault?.defaultOptoutId
      )
      const fallbackOptoutId = defaultOptoutForSend?._id ?? optoutList?.at(0)?._id ?? ''
      if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT)) {
        finalData = {...finalData, optout: false, replyStopToOptOut: false}
      } else if (quickSms) {
        if (!finalData.optout && !finalData.replyStopToOptOut) {
          if (isAlphaSender) {
            finalData.replyStopToOptOut = false
            finalData.optout = true
            finalData.optoutId = finalData.optoutId || fallbackOptoutId
          } else {
            finalData.replyStopToOptOut = true
          }
        }
      }

      if (!globalSettings?.includes(GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT)) {
        if (!quickSms) {
          finalData = {...finalData, optout: false, replyStopToOptOut: false}
        }
      } else if (!quickSms) {
        if (!finalData.optout && !finalData.replyStopToOptOut) {
          if (isAlphaSender) {
            finalData.replyStopToOptOut = false
            finalData.optout = true
            finalData.optoutId = finalData.optoutId || fallbackOptoutId
          } else {
            finalData.replyStopToOptOut = true
          }
        }
      }

      setSuccess(true)
      if (quickSms) {
        const requiredCredit =
          processData(sendData?.message ?? '', replyStopToOptOutCount + optoutCount, isAlphaId)
            ?.credit * contactList?.length
        if (credits?.credits?.['sms'] < requiredCredit) {
          setPurchaseModelData({
            type: 'sms',
            purchaseCredit: requiredCredit > minimumCredit ? requiredCredit : minimumCredit,
            minimum: requiredCredit,
          })
          setPurchasePopupModal(true)
        } else {
          if (CustomReplyReport !== undefined) {
            dispatch(
              fetchAsyncQuickSms({
                ...finalData,
                gatewayMessageId: CustomReplyReport?.id,
                isReplied: true,
              })
            ).then((res: any) => {
              if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
            })
            dispatch(getCampaignReplies({id: CustomReplyReport?.ReportId?.id}))
            setError({})
            dispatch(
              QuickMsgDraftData({
                ...initialData,
              })
            )
            setSendData({
              ...initialData,
            })
            handleClose()
          } else {
            if (isDefaultRegion) {
              dispatch(
                fetchAsyncQuickSms({
                  ...finalData,
                })
              ).then((res: any) => {
                if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())
              })
            } else {
              postUsQM({
                action: 'send_sms',
                data: {
                  ...finalData,
                },
              }).then((res) => {
                if ('data' in res) {
                  if (res.data?.error && Object.keys(res.data?.error).length > 0) {
                    toast.error(res?.data?.message)
                  } else {
                    toast.success('request is being processed')
                  }
                } else if ('error' in res) {
                  toast.error(res.error)
                }
              })
            }

            setError({})
            dispatch(
              QuickMsgDraftData({
                ...initialData,
              })
            )
            setSendData({
              ...initialData,
            })
            handleClose()
          }
        }
      } else {
        const contactList = sendData.contacts?.map((key: any) => (key?.value ? key?.value : key))
        let mediaDataCondition: any = sendData?.media
        if (
          isEmpty(sendData?.media) &&
          typeof sendData?.media == 'string' &&
          !sendData?.media?.startsWith('data:')
        ) {
          mediaDataCondition =
            isEmpty(sendData?.media) && typeof sendData?.media == 'string' && sendData?.media !== ''
              ? JSON.stringify(sendData?.urlData)
              : sendData?.media
        }
        let mmsFinalData: any = {
          media: mediaDataCondition,
          senderType: sendData.senderType,
          gif: sendData.gif,
          sender: sendData.sender,
          message: replaceMessageWith(sendData.message, ''),
          contacts: JSON.stringify(contactList),
          countryCode: '61',
          optout: sendData.optout,
          replyStopToOptOut: sendData.replyStopToOptOut,
          landingPage: sendData.landingPageId ? true : false,
          landingPageId: sendData.landingPageId,
          subject: sendData.subject,
        }
        if (sendData?.longUrl?.length > 0) {
          mmsFinalData.longUrl = JSON.stringify(longUrl)
        }
        if (sendData?.optoutId !== '' && sendData?.optoutId !== undefined) {
          mmsFinalData = {...mmsFinalData, optoutId: sendData.optoutId}
        }

        let data = new FormData()
        for (var key in mmsFinalData) {
          data.append(key, mmsFinalData[key])
        }

        const requiredCredit = 1 * contactList?.length
        if (credits?.credits?.['mms'] < requiredCredit) {
          setPurchaseModelData({
            type: 'mms',
            purchaseCredit: requiredCredit > minimumCredit ? requiredCredit : minimumCredit,
            minimum: requiredCredit,
          })
          setPurchasePopupModal(true)
        } else {
          dispatch(startLoadding())
          if (isDefaultRegion) {
            dispatch(fetchAsyncQuickMms(data)).then((res: any) => {
              if (!(isAdmin === 'true')) dispatch(FirstTimeApprovalData())

              if (
                res &&
                res.payload &&
                res.payload.messsage &&
                typeof res.payload.messsage === 'string'
              ) {
                if (res?.payload?.messsage?.includes('waiting for admin approval')) {
                  toast.success(res.payload.messsage)
                }
              }
            })
          } else if ([REGION.US, REGION.UK].includes(userRegion)) {
            // TODO: remove UK
            // For international only US can send MMS
            if (typeof sendData?.media !== 'string') {
              try {
                mmsFinalData.media = await fileToBase64(mmsFinalData.media)
              } catch (error) {
                console.error('format media failed:', error)
                mmsFinalData.media = ''
              }
            }

            if (sendData?.longUrl?.length > 0) {
              mmsFinalData.longUrl = longUrl
            }

            mmsFinalData.contacts = contactList

            postUsQM({
              action: 'send_mms',
              data: {
                ...mmsFinalData,
              },
            }).then((res) => {
              if ('data' in res) {
                if (res.data?.error && Object.keys(res.data?.error).length > 0) {
                  toast.error(res?.data?.message)
                } else {
                  toast.success('request is being processed')
                }
              } else if ('error' in res) {
                toast.error(res.error)
              }
            })
          }
          dispatch(
            QuickMsgDraftData({
              ...initialData,
            })
          )
          setSendData({
            ...initialData,
          })
          handleClose()
        }
      }
    }
  }

  const Giphypopup = useMemo(
    () => (
      <GiphyPopup
        show={giphyShow}
        data={sendData}
        setData={setSendData}
        handleClose={() => setGiphyShow(false)}
      />
    ),
    [giphyShow, sendData]
  )

  const dedicatedOptionSMS: any =
    virtualNumber && Array.isArray(virtualNumber)
      ? virtualNumber
          ?.filter((key: any) => (toUpper(key?.type) === 'SMS' || toUpper(key?.type) === 'VOICE') && key?.status == 'active')
          ?.map((key: any) => ({
            value: key?.audNumber,
            label: key?.audNumber,
            disabled: key?.status === 'inactive',
          }))
      : []

  const dedicatedOptionMMS: any =
    virtualNumber && Array.isArray(virtualNumber)
      ? virtualNumber
          ?.filter((key: any) => toUpper(key?.type) === 'MMS' && key?.status === 'active')
          ?.map((key: any) => ({
            value: key?.audNumber,
            label: key?.audNumber,
            disabled: key?.status === 'inactive',
          }))
      : []

  const businessNameOption: any =
    bussinessName && Array.isArray(bussinessName)
      ? bussinessName
          ?.filter((key: any) => key?.status === 'ACTIVE')
          ?.map((key: any) => ({
            value: key?.businessname,
            label: key?.businessname,
          }))
      : []

  const customNumberOption: any =
    CustomNumberList && Array.isArray(CustomNumberList)
      ? CustomNumberList?.filter((key: any) => key?.status === 'active')?.map((key: any) => ({
          value: key?.number,
          label: key?.number,
        }))
      : []

  // const dataOption = [
  //   {value: '#SharedNum#', label: '#SharedNum#'},
  //   ...dedicatedOptionMMS,
  //   ...dedicatedOptionSMS,
  //   ...businessNameOption,
  //   ...customNumberOption,
  // ]

  const handleInputChange = (e: any) => {
    setSearchName(e)
  }
  const debouncedSearchTerm = useDebounce(searchName, 500)
  useEffect(() => {
    // dispatch(GetContactSearch(searchName))
  }, [debouncedSearchTerm])

  const handleTemplateClose = () => {
    setTemplateName('')
    setTemplateNameModel(false)
  }

  const senderTypeData = [
    {name: '#SharedNum#', array: [{value: '#SharedNum#', label: '#SharedNum#'}]},
    {name: 'dedicatedNumber', array: [...dedicatedOptionSMS, ...dedicatedOptionMMS]},
    {name: 'businessName', array: businessNameOption},
    {name: 'customNumber', array: customNumberOption},
  ]

  const alphaID = ['businessName', 'customNumber']

  useEffect(() => {
    if (isAdmin === 'false') {
      dispatch(getDedicatedNumberList())
      dispatch(GetAllData())
      dispatch(GetAllCustomeData())
      dispatch(stopLoading())
    }
  }, [quickSms])

  const renderOptOutText = () => {
    let message = ''

    const optOutSettingType = quickSms
      ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
      : GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
    if (!globalSettings?.includes(optOutSettingType)) {
      return ''
    }

    if (sendData?.optout) {
      message = `STOP: ${optOutBaseUrl}/vc`
    }

    if (sendData?.replyStopToOptOut) {
      message = "Reply 'STOP' to opt-out"
    }

    return message
  }

  const renderShortLink = (textMessage: string) => {
    if (sendData?.longUrl?.length > 0) {
      const uniqueUrl = Array.from(
        new Map(sendData.longUrl.map((item: any) => [item.shortUrl, item])).values()
      )
      for (let index = 0; index < uniqueUrl.length; index++) {
        const element: any = uniqueUrl[index]
        let tempShortUrl = `${defaultShortUrl}/${element.shortUrl}`

        if (textMessage.split(tempShortUrl).length - 1) {
          textMessage = textMessage.replace(tempShortUrl, `${tempShortUrl}-xxxxx`)
        }
      }

      return textMessage
    }
    return textMessage
  }

  const removeOptOutOrReply = (message: string) => {
    let replacedMessage = renderShortLink(message)

    if (replacedMessage?.includes("Reply 'STOP' to opt-ou")) {
      return replaceMessageWith(replacedMessage, '')
    }

    if (replacedMessage?.includes(`STOP: ${optOutBaseUrl}/v`)) {
      return replaceMessageWith(replacedMessage, '')
    }

    return replacedMessage
  }

  const isDisableSendButton = useMemo(() => {
    return (
      !sendData?.message.length ||
      !sendData.contacts.length ||
      sendData.contacts.length > QUICK_CONTACT_LIMIT ||
      !_.isEmpty(error)
    )
  }, [sendData, error])

  const renderOptOutTextMessage = () => {
    let message = ''

    const optOutSettingType = quickSms
      ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
      : GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
    if (!globalSettings?.includes(optOutSettingType)) {
      return ''
    }

    if (sendData?.optout !== true) {
      if (sendData.replyStopToOptOut) {
        message = "Reply 'STOP' to opt-out"
      }
    } else {
      if (sendData?.optout) {
        message = `STOP: ${optOutBaseUrl}/xxxxxx`
      }
    }

    if (removeOptOutOrReply(sendData?.message) !== '') {
      return <span>{message}</span>
    }
  }
  const MenuListComponent = (props: any) => {
    const {isVisible, ...rest} = props
    return (
      <components.MenuList {...rest}>
        {props.children}

        {rest?.options?.length == 1 && isAdmin === 'false' ? (
          <>
            {isShowCredit && [REGION.AU, REGION.US].includes(userRegion) && (
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='button-tooltip'>Create new dedicated number</Tooltip>}
              >
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    gap: '6px',
                    cursor: 'pointer',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderTop: '1px solid #F4F5F7',
                    padding: '10px 0px 10px 0px',
                  }}
                  className={clsx({'d-none': !isDefaultRegion})}
                  onClick={() => {
                    setVisible(true)
                  }}
                >
                  <i
                    style={{
                      color: '#7950F2',
                      fontWeight: 'bold !important',
                    }}
                    className='bi bi-plus-lg'
                  ></i>
                  <p
                    style={{
                      color: '#7950F2',
                      margin: 0,
                      fontWeight: 600,
                    }}
                  >
                    Create dedicated number
                  </p>
                </div>
              </OverlayTrigger>
            )}
            {isVisible && (
              <>
                {[REGION.AU, REGION.US, REGION.UK].includes(userRegion) && (
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip id='button-tooltip'>Create new custom business name</Tooltip>}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        gap: '6px',
                        cursor: 'pointer',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderTop: '1px solid #F4F5F7',
                        padding: '10px 0px 10px 0px',
                      }}
                      className={clsx({
                        'd-none': !isDefaultRegion && ![REGION.UK].includes(userRegion),
                      })}
                      onClick={() => {
                        setName(true)
                      }}
                    >
                      <i
                        style={{
                          color: '#7950F2',
                          fontWeight: 'bold !important',
                        }}
                        className='bi bi-plus-lg'
                      ></i>
                      <p
                        style={{
                          color: '#7950F2',
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        Create custom business name
                      </p>
                    </div>
                  </OverlayTrigger>
                )}
                {[REGION.AU, REGION.US].includes(userRegion) && (
                  <OverlayTrigger
                    placement='top'
                    overlay={<Tooltip id='button-tooltip'>Create new custom number</Tooltip>}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        gap: '6px',
                        cursor: 'pointer',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderTop: '1px solid #F4F5F7',
                        padding: '10px 0px 10px 0px',
                      }}
                      className={clsx({
                        'd-none': !isDefaultRegion,
                      })}
                      onClick={() => {
                        setCustomNumber(true)
                      }}
                    >
                      <i
                        style={{
                          color: '#7950F2',
                          fontWeight: 'bold !important',
                        }}
                        className='bi bi-plus-lg'
                      ></i>
                      <p
                        style={{
                          color: '#7950F2',
                          margin: 0,
                          fontWeight: 600,
                        }}
                      >
                        Create custom number
                      </p>
                    </div>
                  </OverlayTrigger>
                )}
              </>
            )}
          </>
        ) : null}
      </components.MenuList>
    )
  }

  const purchaseModal = useMemo(
    () => (
      <>
        {isAdmin === 'false' ? (
          <PurchasePopup
            show={purchasePopupModal}
            purchaseModelData={purchaseModelData}
            handleClose={() => {
              setPurchasePopupModal(false)
            }}
          />
        ) : null}
      </>
    ),
    [purchasePopupModal]
  )

  const contactListPopup = useMemo(
    () => (
      <QMContactListPopup
        show={contactListModel}
        handleClose={() => {
          setContactListModel(false)
        }}
        selectedCallback={(e: String[]) => {
          let tmpContacts = [...sendData.contacts]

          if (e.length > 0) {
            e.forEach((el) => {
              if (!tmpContacts.find((f) => f.value === el)) {
                if (tmpContacts.length > QUICK_CONTACT_LIMIT) {
                  return
                }
                tmpContacts.push({label: el, value: el})
                return
              }
            })
          }
          setSendData({
            ...sendData,
            contacts: tmpContacts,
          })
          setContactListModel(false)
        }}
        status={'subscribed'}
      />
    ),
    [contactListModel]
  )

  const contactSegmentListPopup = useMemo(
    () => (
      <QMContactSegmentListPopup
        show={contactSegmentListModel}
        handleClose={() => {
          setContactSegmentListModel(false)
        }}
        selectedCallback={(e: String[]) => {
          let tmpContacts = [...sendData.contacts]

          if (e.length > 0) {
            e.forEach((el) => {
              if (!tmpContacts.find((f) => f.value === el)) {
                if (tmpContacts.length > QUICK_CONTACT_LIMIT) {
                  return
                }
                tmpContacts.push({label: el, value: el})
                return
              }
            })
          }
          setSendData({
            ...sendData,
            contacts: tmpContacts,
          })
          setContactSegmentListModel(false)
        }}
      />
    ),
    [contactSegmentListModel, sendData]
  )

  const handleCloseWithData = async () => {
    let base64String = sendData?.media
    if (isEmpty(sendData?.media) && !(typeof sendData?.media == 'string')) {
      base64String = await fileToBase64(sendData?.media)
    }
    dispatch(QuickMsgDraftData({...sendData, media: base64String}))
    setCustomReplyReport()
    handleClose()
  }

  return (
    <React.Fragment>
      {contactListPopup}
      {contactSegmentListPopup}
      {purchaseModal}
      {isAdmin === 'false' ? (
        <>
          <StripeJSProvider>
            {({stripe}: any) =>
              stripe ? (
                <Elements stripe={stripe}>
                  <VirtualNumbersModal
                    show={visible}
                    handleClose={() => {
                      setIsRefresh(!isRefresh)
                      setVisible(false)
                    }}
                  />
                </Elements>
              ) : null
            }
          </StripeJSProvider>
          <CreateBusinessNamePopup
            show={name}
            handleClose={() => {
              setIsRefresh(!isRefresh)
              setName(false)
            }}
          />
          <CreateCustomNumber
            show={customNumber}
            handleClose={() => {
              setIsRefresh(!isRefresh)
              setCustomNumber(false)
            }}
          />
        </>
      ) : null}
      {templateNameModel && (
        <>
          <Modal
            show={templateNameModel}
            onHide={handleTemplateClose}
            dialogClassName={`modal-dialog-centered mw-450px save-template-modal`}
          >
            <div>
              <label className='col-form-label fs-6 fw-bold required' htmlFor='audNumber'>
                Template
              </label>
              <input
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                onChange={(e: any) => setTemplateName(e.target.value)}
                placeholder='Template Name'
              />
            </div>
            <div className='save-action-buttons'>
              <button className='btn btn-primary' onClick={handleTemplateClose}>
                Cancel
              </button>
              <button
                className='btn btn-primary'
                onClick={() => {
                  const addLongUrl =
                    sendData.longUrl?.length > 0 ? JSON.stringify(sendData.longUrl) : undefined
                  const data: any = {
                    type: sendData.camp_type?.toUpperCase(),
                    name: templateName,
                    subjectTitle: sendData.subject,
                    allowShortUrl: '',
                    qr_code: '',
                    gif: sendData.gif,
                    mediaType: '',
                    message: sendData.message,
                    longUrl: addLongUrl,
                    media: sendData.media,
                    replyStopToOptOut: sendData?.replyStopToOptOut
                      ? sendData?.replyStopToOptOut
                      : false,
                  }

                  if (
                    sendData?.optout &&
                    sendData.optout === true &&
                    sendData?.optoutId &&
                    sendData.optoutId !== ''
                  ) {
                    data.optout = sendData.optout
                    data.optoutId = sendData.optoutId
                  }

                  if (sendData?.landingPageId && sendData.landingPageId !== '') {
                    data.landingPage = true
                    data.landingPageId = sendData.landingPageId
                  }

                  const templateSettingType =
                    sendData.camp_type === 'sms'
                      ? GLOBAL_SETTINGS_TYPE.QUICK_SMS_REPLY_STOP_OUTPUT
                      : GLOBAL_SETTINGS_TYPE.QUICK_MMS_REPLY_STOP_OUTPUT
                  if (!globalSettings?.includes(templateSettingType)) {
                    data.optout = false
                    data.replyStopToOptOut = false
                  }

                  if (sendData?.forwardReplyTo) {
                    data.forwardReplyTo = sendData?.forwardReplyTo
                  }

                  let finalData = new FormData()
                  for (var key in data) {
                    finalData.append(key, data[key])
                  }

                  dispatch(CreateNewTemplate(finalData))
                  handleTemplateClose()
                }}
              >
                Submit
              </button>
            </div>
          </Modal>
        </>
      )}
      <Modal
        show={preview}
        onHide={handleCloseWithData}
        className={`quickMessageModal ${show ? 'right' : 'left'} `}
        dialogClassName={`modal-dialog-centered nopreviweQuickMessage modal-xl`}
      >
        {Giphypopup}
        <div className='card rounded-0 w-100' id='kt_drawer_chat_messenger'>
          <div
            className='card-header pe-5 quick-message-header'
            id='kt_drawer_chat_messenger_header'
          >
            <div className='card-title'>
              <div className='d-flex flex-column justify-content-center'>
                <a
                  href='#'
                  className='text-gray-900 text-hover-primary fs-3 fw-bolder lh-1'
                  style={{textDecoration: 'none'}}
                  data-testid='txtQuickMessage'
                >
                  Quick Message
                </a>
              </div>
            </div>

            <div className='d-flex flex-column'>
              <div
                className='btn btn-active-light-primary btn-icon btn-sm'
                onClick={handleCloseWithData}
                id='kt_drawer_chat_close'
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
              </div>
            </div>
          </div>

          <form className='form quick-message-form' noValidate>
            <div className='card-body'>
              <div className='d-flex'>
                <div className='row'>
                  <div className='col-8'>
                    <div className='row mb-2' data-kt-buttons='true'>
                      <div className='form-group mb-2'>
                        <div className='row align-items-center mb-2 d-flex justify-content-between'>
                          <label className='col custom-form-label'>{'To (Recipients)'}</label>
                          <label
                            className='col-auto text-end custom-form-label fw-bold'
                            data-testid='txtTotalNumbers'
                          >
                            {sendData?.contacts.length || 0} Numbers Added
                          </label>
                        </div>
                        <div
                          className='d-flex align-items-start justify-content-between'
                          style={{gap: '0.625rem'}}
                        >
                          <div className='w-100'>
                            <CreatableSelect
                              isMulti
                              styles={{
                                dropdownIndicator: (provided, state) => ({
                                  ...provided,
                                  display: 'none', // Hide the dropdown indicator
                                }),
                              }}
                              className={clsx({
                                'border border-danger':
                                  !sendData.contacts.length && error?.contacts,
                              })}
                              placeholder='Input Phone Number'
                              data-testid='inputPhoneNumber'
                              classNamePrefix='create-select'
                              value={sendData?.contacts}
                              escapeClearsValue={false}
                              formatCreateLabel={(value) => {
                                if (numberWithSymbol(value.replaceAll(' ', ''))) {
                                  return `Create  ${value}`
                                }
                                return null
                              }}
                              onBlur={(e) => handleToSelectChangeValue(e.currentTarget.value)}
                              onInputChange={handleInputChange}
                              onChange={(e) => handleToSelectChangeValue(e)}
                            />

                            {/* Error Message */}
                            {!sendData.contacts.length && error?.contacts && (
                              <div className='mt-2'>
                                <p className='text-danger mb-1'>{error.contacts}</p>
                              </div>
                            )}

                            {sendData.contacts?.length > QUICK_CONTACT_LIMIT && (
                              <p className='text-danger mb-1'>
                                Max number that send is {QUICK_CONTACT_LIMIT}
                              </p>
                            )}
                          </div>

                          <div>
                            <div className='dropdown w-100' ref={addContactRef}>
                              <button
                                className='btn btn-light-primary dropdown-toggle w-100'
                                style={{height: '44px'}}
                                type='button'
                                id='dropdownMenuButton'
                                onClick={() => setIsAddContactOpen(!isAddContactOpen)}
                              >
                                Search Contact{' '}
                                {isAddContactOpen ? (
                                  <ChevronUp className='ms-5' />
                                ) : (
                                  <ChevronDown className='ms-5' />
                                )}
                              </button>

                              <Select
                                isSearchable={false}
                                menuIsOpen={isAddContactOpen}
                                styles={{
                                  container: (provided) => ({
                                    ...provided,
                                    position: 'absolute',
                                    right: 0,
                                    minWidth: '240px',
                                    textAlign: 'right',
                                  }),
                                }}
                                onChange={(e: any) => {
                                  if (e.value === 'search_contact') {
                                    setContactListModel(true)
                                  }

                                  if (e.value === 'search_contact_by_segment') {
                                    setContactSegmentListModel(true)
                                  }
                                }}
                                value={{}}
                                options={[
                                  {value: 'search_contact', label: 'Search Contacts'},
                                  ...(isDefaultRegion
                                    ? [
                                        {
                                          value: 'search_contact_by_segment',
                                          label: 'Search Contacts By Segments',
                                        },
                                      ]
                                    : []),
                                ]}
                                className={`common-select`}
                                onMenuClose={() => setIsAddContactOpen(!isAddContactOpen)}
                                components={{Control: (props: any) => <i></i>}}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className='form-group mb-8 mt-8'>
                        <label className='custom-form-label mb-3'>Select Your Message Type</label>

                        <div className='col-12 mt-0'>
                          <div className='d-flex flex-column'></div>
                          <div className='row mx-0'>
                            <div className='ps-1' style={{width: '160px'}}>
                              <input
                                type='radio'
                                className='btn-check'
                                name='TypeOfMsg'
                                checked={quickSms === true}
                                placeholder='Select Your Sender ID'
                                id='quick_sms_radio'
                                onChange={async () => {
                                  let sendNumber = virtualNumber?.find(
                                    (val: any) => val?.isDefault === true && val?.type === 'SMS'
                                  )?.audNumber

                                  let def = sendNumber === undefined ? '#SharedNum#' : sendNumber
                                  setQuickSms(!quickSms)
                                  let base64String = sendData?.media
                                  if (
                                    isEmpty(sendData?.media) &&
                                    !(typeof sendData?.media == 'string')
                                  ) {
                                    base64String = await fileToBase64(sendData?.media)
                                  }
                                  dispatch(
                                    QuickMsgDraftData({
                                      ...sendData,
                                      media: base64String,
                                      sender: def,
                                      camp_type: 'sms',
                                      senderType: '',
                                      optoutLabel: '',
                                      optoutId: '',
                                    })
                                  )
                                  setSendData({
                                    ...sendData,
                                    sender: def,
                                    camp_type: 'sms',
                                    senderType: '',
                                    optoutLabel: '',
                                    optoutId: '',
                                  })
                                }}
                              />
                              <label
                                className='btn btn-outline btn-outline-dashed btn-outline-default p-4 w-100 py-3'
                                htmlFor='quick_sms_radio'
                              >
                                <span className='fs-5 fw-500' data-testid='btnSMSMessage'>
                                  SMS
                                </span>
                              </label>
                            </div>
                            <div
                              className={`ps-1 ${
                                !isDefaultRegion && ![REGION.US, REGION.UK].includes(userRegion)
                                  ? 'd-none'
                                  : ''
                              }`} // TODO: Remove UK
                              style={{width: '160px'}}
                            >
                              <input
                                type='radio'
                                className='btn-check'
                                name='TypeOfMsg'
                                checked={quickSms === false}
                                id='quick_mms_radio'
                                onChange={async () => {
                                  let sendNumber = virtualNumber?.find(
                                    (val: any) => val?.isDefault === true && val?.type === 'MMS'
                                  )?.audNumber
                                  let def = sendNumber === undefined ? '#SharedNum#' : sendNumber
                                  setQuickSms(!quickSms)
                                  let base64String = sendData?.media
                                  if (
                                    isEmpty(sendData?.media) &&
                                    !(typeof sendData?.media == 'string')
                                  ) {
                                    base64String = await fileToBase64(sendData?.media)
                                  }
                                  dispatch(
                                    QuickMsgDraftData({
                                      ...sendData,
                                      media: base64String,
                                      sender: def,
                                      camp_type: 'mms',
                                      senderType: '',
                                      optoutLabel: '',
                                      optoutId: '',
                                    })
                                  )
                                  setSendData({
                                    ...sendData,
                                    sender: def,
                                    camp_type: 'mms',
                                    senderType: '',
                                    optoutLabel: '',
                                    optoutId: '',
                                  })
                                }}
                              />

                              <label
                                className='btn btn-outline btn-outline-dashed btn-outline-default p-4 w-100 py-3'
                                htmlFor='quick_mms_radio'
                              >
                                <span className='fs-5 fw-500' data-testid='btnMMSMessage'>
                                  MMS
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='form-group mb-8' style={{zIndex: 10}}>
                        <label className='custom-form-label mb-3'>{'From (Sender ID)'}</label>
                        {quickSms == true ? (
                          <Select
                            components={{
                              MenuList: (props) => (
                                <MenuListComponent isVisible={true} {...props} />
                              ),
                            }}
                            onChange={(e: any) => {
                              if (
                                alphaID.includes(findMatchingArrayName(e?.value, senderTypeData))
                              ) {
                                const DefaultOptout = optoutList?.find(
                                  (key: any) => key?._id == OptOutDefault?.defaultOptoutId
                                )
                                let tempOptout: any = {optout: false, optoutId: ''}
                                if (DefaultOptout?.title) {
                                  tempOptout = {
                                    ...tempOptout,
                                    optout: true,
                                    optoutId: DefaultOptout?._id,
                                    optoutLabel: DefaultOptout?.title,
                                  }
                                } else {
                                  if (optoutList?.length > 0) {
                                    tempOptout = {
                                      ...tempOptout,
                                      optout: true,
                                      optoutId: optoutList?.[0]?._id,
                                      optoutLabel: optoutList?.[0]?.title,
                                    }
                                  }
                                }
                                setSendData({
                                  ...sendData,
                                  sender: e?.value,
                                  senderType: findMatchingArrayName(e?.value, senderTypeData),
                                  replyStopToOptOut: false,
                                  ...tempOptout,
                                })
                              } else {
                                let replyStopToOptOut = !!sendData?.optoutId
                                  ? sendData?.replyStopToOptOut
                                  : true

                                if (!optoutList?.length) {
                                  replyStopToOptOut = false
                                }

                                setSendData({
                                  ...sendData,
                                  replyStopToOptOut,
                                  sender: e?.value,
                                  senderType: findMatchingArrayName(e?.value, senderTypeData),
                                })
                              }
                            }}
                            value={
                              sendData?.sender && sendData?.sender.length > 0
                                ? {value: sendData?.sender, label: sendData?.sender}
                                : {
                                    value: [REGION.AU, REGION.US].includes(userRegion)
                                      ? '#SharedNum#'
                                      : '',
                                    label: [REGION.AU, REGION.US].includes(userRegion)
                                      ? '#SharedNum#'
                                      : 'Select Sender',
                                  }
                            }
                            options={[
                              ...([REGION.AU, REGION.US].includes(userRegion)
                                ? [{value: '#SharedNum#', label: '#SharedNum#'}]
                                : []),
                              ...([REGION.AU, REGION.US].includes(userRegion)
                                ? dedicatedOptionSMS
                                : []),
                              ...([REGION.AU, REGION.US].includes(userRegion)
                                ? dedicatedOptionMMS
                                : []),
                              ...([REGION.AU, REGION.US, REGION.UK].includes(userRegion)
                                ? businessNameOption
                                : []),
                              ...([REGION.AU, REGION.US].includes(userRegion)
                                ? customNumberOption
                                : []),
                            ]}
                            data-testid='ddSenderID'
                            isOptionDisabled={(option: any, value: any) =>
                              option?.disabled ? option?.disabled : false
                            }
                          />
                        ) : (
                          <Select
                            components={{
                              MenuList: (props) => (
                                <MenuListComponent isVisible={false} {...props} />
                              ),
                            }}
                            className={clsx({
                              'border border-danger': error?.sender && !sendData?.senderType,
                            })}
                            onChange={(e: any) => {
                              if (
                                alphaID.includes(findMatchingArrayName(e?.value, senderTypeData))
                              ) {
                                const DefaultOptout = optoutList?.find(
                                  (key: any) => key?._id == OptOutDefault?.defaultOptoutId
                                )
                                let tempOptout: any = {optout: false, optoutId: ''}
                                if (DefaultOptout?.title) {
                                  tempOptout = {
                                    ...tempOptout,
                                    optout: true,
                                    optoutId: DefaultOptout?._id,
                                    optoutLabel: DefaultOptout?.title,
                                  }
                                } else {
                                  if (optoutList?.length > 0) {
                                    tempOptout = {
                                      ...tempOptout,
                                      optout: true,
                                      optoutId: optoutList?.[0]?._id,
                                      optoutLabel: optoutList?.[0]?.title,
                                    }
                                  }
                                }
                                setSendData({
                                  ...sendData,
                                  sender: e?.value,
                                  senderType: findMatchingArrayName(e?.value, senderTypeData),
                                  replyStopToOptOut: false,
                                  ...tempOptout,
                                })
                              } else {
                                let replyStopToOptOut = !!sendData?.optoutId
                                  ? sendData?.replyStopToOptOut
                                  : true

                                if (!optoutList?.length) {
                                  replyStopToOptOut = false
                                }

                                setSendData({
                                  ...sendData,
                                  replyStopToOptOut,
                                  sender: e?.value,
                                  senderType: findMatchingArrayName(e?.value, senderTypeData),
                                })
                              }
                            }}
                            value={
                              sendData?.sender && sendData?.sender.length > 0
                                ? {value: sendData?.sender, label: sendData?.sender}
                                : {value: '#SharedNum#', label: '#SharedNum#'}
                            }
                            options={[
                              {value: '#SharedNum#', label: '#SharedNum#'},
                              ...dedicatedOptionMMS,
                              // ...businessNameOption,
                              // ...customNumberOption,
                            ]}
                            isOptionDisabled={(option: any, value: any) =>
                              option?.disabled ? option?.disabled : false
                            }
                          />
                        )}
                        {error?.sender && !sendData?.senderType && (
                          <p style={{color: 'red'}} className='mt-2'>
                            {error?.sender}
                          </p>
                        )}
                      </div>
                      {quickSms === false && (
                        <>
                          <div className='col-12 col-lg-12 col-md-12 col-sm-12 col-xl-12'>
                            <div className='mt-0'>
                              <label className='custom-form-label'>Subject line</label>
                              <input
                                type='text'
                                value={sendData?.subject}
                                data-testid='inputSubjectLine'
                                className='form-control form-control-lg form-control-solid'
                                placeholder='Type optional subject line here'
                                onChange={(e: any) =>
                                  setSendData({...sendData, subject: e?.target?.value})
                                }
                              />
                            </div>
                          </div>
                          <div className='col-lg-5 col-md-6 col-sm-12 col-xl-4 mb-4 mt-8'>
                            <div className='d-flex flex-column media_dropdown'>
                              <label className='custom-form-label'>Media</label>
                              <input
                                ref={mediaInput}
                                accept={'.jpeg,.png,.vcf'}
                                type='file'
                                name='file'
                                data-testid='inputUploadMedia'
                                style={{display: 'none'}}
                                onChange={(e: any) => {
                                  let data = e.target.files[0]
                                  let err = {...error}
                                  delete err?.media
                                  data?.size > MAX_FILE_SIZE &&
                                    setError({
                                      ...error,
                                      media: 'Upload size should be less than 1.5mb',
                                    })
                                  data &&
                                    data?.size < MAX_FILE_SIZE &&
                                    setSendData({...sendData, media: data, gif: ''})
                                  setError(err)
                                }}
                              />
                              <input
                                ref={mediaInputVideo}
                                accept={'.jpeg,.png,.jpg,.gif,.mp4,.mp3,video/*,.vcf'}
                                type='file'
                                name='file'
                                data-testid='inputUploadGif'
                                style={{display: 'none'}}
                                onChange={(e: any) => {
                                  let data = e.target.files[0]
                                  let err = {...error}
                                  delete err?.media

                                  data?.size > MAX_FILE_SIZE &&
                                    setError({
                                      ...error,
                                      media: 'Upload size should be less than 1.5mb',
                                    })

                                  if (data && data?.size < MAX_FILE_SIZE) {
                                    setSendData({...sendData, media: data, gif: ''})
                                    setError(err)
                                  }
                                }}
                              />
                              <Select
                                value={{value: '', label: 'Add media'}}
                                placeholder='Add Media'
                                isSearchable={false}
                                onChange={(e: any) => {
                                  // if (e.value == '1') {
                                  //   mediaInput.current.click()
                                  // }
                                  if (e.value == '1') {
                                    mediaInputVideo.current.click()
                                  }
                                  if (e.value == '3') {
                                    setGiphyShow(true)
                                  }
                                }}
                                options={[
                                  {value: '1', label: 'Upload File'},
                                  // {value: '2', label: 'Upload video'},
                                  {value: '3', label: 'Select GIPHY'},
                                ]}
                              />
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                }}
                                className='m-0 text-muted pt-2'
                              >
                                File size should be less than 1.5 MB.
                              </p>

                              {(sendData?.media !== '' || sendData.gif !== '') && (
                                <span className='d-flex flex-row text-muted fs-7 mb-0 mt-3'>
                                  Media selected:{sendData.media !== '' && sendData.media?.name}
                                  {sendData.gif !== '' && 'GIF'}{' '}
                                  <span className='text-dark fs-7 mb-2 ms-1'></span>
                                  <span className='ms-2'>
                                    <WSButton
                                      type='button'
                                      className={
                                        'btn btn-sm btn-icon btn-light btn-light-danger fw-500 fs-7 h-100 mh-20px w-20px d-flex justify-content-center align-items-center'
                                      }
                                      onClick={() => {
                                        mediaInput.current.value = null
                                        mediaInputVideo.current.value = null
                                        setSendData({...sendData, media: '', gif: ''})
                                      }}
                                      iconPath='/media/icons/duotune/arrows/arr061.svg'
                                      iconClass='svg-icon-8 mb-1'
                                    />
                                  </span>
                                </span>
                              )}
                            </div>
                          </div>
                          {error?.media && (
                            <p style={{color: 'red'}} className='mb-2'>
                              {error?.media}
                            </p>
                          )}
                        </>
                      )}
                      <div className={clsx({'border border-danger': error?.message})}>
                        <MessageBoxV2
                          setError={setError}
                          error={error}
                          setUserMessage={setSendData}
                          userMessage={sendData}
                          options={options}
                          quickSms={quickSms}
                          isAlphaId={isCustomPriceOrAlphaId}
                          showSelect={[
                            'template',
                            'customfield',
                            'weblink',
                            'opt-out',
                            'landingPage',
                          ]}
                          itQuickMessage={true}
                          setIsForward={setIsForward}
                          enableUnicodeModal={true}
                        />
                      </div>
                      <span className='text-danger mb-2'>{error?.message}</span>
                      {/* <div className='d-flex align-items-center gap-4 mb-6'>
                        <h6
                          style={{
                            fontWeight:QUICK_CONTACT_LIMIT 0,
                            margin: 0,
                          }}
                        >
                          Send message to unsubscribe contact
                        </h6>
                        <Form.Check
                          // onChange={(e) => setToggleHeader(!toggleHeader)}
                          // checked={toggleHeader}
                          className='unsub-switch'
                          type='switch'
                          id='custom-switch'
                        />
                      </div> */}
                      {isDefaultRegion && sendData.camp_type === 'sms' && (
                        <div className='d-flex justify-content-between'>
                          <div className='form-group mb-6 mt-6'>
                            <div
                              className='col-12 form-check form-check-custom form-check-sm form-check-solid mb-5'
                              style={{marginTop: '0px !important'}}
                            >
                              <input
                                className='form-check-input me-5'
                                id='contact'
                                type={'checkbox'}
                                onChange={(e) => {
                                  setIsForward(!isForward)
                                }}
                                checked={isForward}
                              />
                              <label
                                htmlFor='contact'
                                style={{
                                  fontSize: '14px',
                                  fontWeight: '400',
                                }}
                              >
                                Forward Incoming Message
                              </label>
                            </div>

                            {isForward && (
                              <input
                                type='text'
                                value={sendData?.forwardReplyTo || ''}
                                data-testid='cbForwardReplyEmail'
                                className='form-control form-control-lg form-control-solid w-100 react-tagsinput-input min-w-400px'
                                placeholder='targetemail1@mail.com, targetemail2@mail.com'
                                onChange={(e) =>
                                  setSendData({...sendData, forwardReplyTo: e.target.value})
                                }
                                style={{fontFamily: 'Poppins, Helvetica, sans-serif'}}
                              />
                            )}

                            <div
                              className='col-12 form-check form-check-custom form-check-sm form-check-solid mb-5'
                              style={{marginTop: '0px !important'}}
                            >
                              <input
                                className='form-check-input me-5'
                                id='contact'
                                data-testid='cbSendLater'
                                type={'checkbox'}
                                onChange={(e) => {
                                  setIsLater(!isLater)
                                }}
                                checked={isLater}
                              />
                              <label
                                htmlFor='contact'
                                style={{
                                  fontSize: '14px',
                                  fontWeight: '400',
                                }}
                              >
                                Send Later
                              </label>
                            </div>
                            {isLater && (
                              <div
                                className='col-12 form-check form-check-custom form-check-sm form-check-solid mb-5'
                                style={{marginTop: '0px !important'}}
                              >
                                <div className=''>
                                  <label htmlFor='' className='mb-2'>
                                    Select Date & Time{' '}
                                    <span className=''>{timezoneLabel}</span>
                                  </label>
                                  <DatePicker
                                    minDate={new Date()}
                                    dateFormat='MMMM d, yyyy h:mm aa'
                                    placeholderText='Select a date'
                                    showTimeSelect
                                    inline
                                    className='form-control form-control-lg form-control-solid'
                                    onChange={(e: any) => {
                                      // Parse the Date object as if it's in the user's timezone
                                      const year = e.getFullYear()
                                      const month = e.getMonth()
                                      const day = e.getDate()
                                      const hours = e.getHours()
                                      const minutes = e.getMinutes()
                                      
                                      // Create moment in user's timezone with the selected date/time values
                                      const selectedMoment = moment.tz([year, month, day, hours, minutes], userTimezone)
                                      const currentMoment = moment.tz(userTimezone)
                                      
                                      if (selectedMoment.isAfter(currentMoment)) {
                                        let err = {...error}
                                        delete err.late
                                        delete err.when
                                        setLaterDate(e)

                                        setError({...err})
                                      } else {
                                        setLaterDate(e)
                                        setError({
                                          ...error,
                                          late: 'Please select proper time to schedule message',
                                          when: 'please select when',
                                        })
                                      }
                                    }}
                                    selected={laterDate}
                                  />
                                  <div>
                                    {moment
                                        .tz(laterDate, moment.tz.guess())
                                        .format('MMMM D, yyyy h:mm a')}
                                  </div>
                                  {error?.late ? (
                                    <span className='text-danger'>
                                      {error?.late}, current time is{' '}
                                      {moment
                                        .tz(userTimezoneNow, userTimezone)
                                        .format('MMMM D, yyyy h:mm a')}
                                    </span>
                                  ) : (
                                    <span className='text-muted text-sm mb-20'>
                                      current time is{' '}
                                      {moment
                                        .tz(userTimezoneNow, userTimezone)
                                        .format('MMMM D, yyyy h:mm a')}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className=''>
                        <div className='d-flex flex-start'>
                          <button
                            id={success === true ? 'kt_drawer_chat_close' : ''}
                            type='submit'
                            disabled={isDisableSendButton}
                            className='btn btn-primary btn-sm p-3 fw-500 me-2 px-5'
                            style={{
                              backgroundColor: isDisableSendButton ? '#7950F27A' : '',
                              color: isDisableSendButton ? '#FFFFFF' : '',
                            }}
                            onClick={handleSubmit}
                          >
                            <span className='indicator-label' data-testid='btnSend'>
                              Send {isLater ? 'later' : 'now'}
                            </span>
                          </button>
                          <div>
                            {isAdmin === 'true' || !isDefaultRegion ? null : (
                              <button
                                className='btn btn-sm p-3 fw-600 gray_bg_purple pull-right px-5'
                                style={{border: '1px solid #7C6EF2'}}
                                type='button'
                                data-testid='btnSaveAsTemplate'
                                onClickCapture={() => {
                                  if (sendData.message != '') setTemplateNameModel(true)
                                }}
                              >
                                Save
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='col-4 NewQuickMsgPreview'>
                    <div className='new_newmessage_right new_newmessage_right_mobile'>
                      <h5>Preview</h5>
                      <nav>
                        <div
                          className='nav nav-tabs'
                          id='nav-tab'
                          role='tablist'
                          data-testid='previewMessageOption'
                        >
                          <button
                            className='nav-link active rounded-end-0'
                            id='nav-preview-on-unlocked'
                            data-bs-toggle='tab'
                            data-bs-target='#nav-preview-on-unlocked-screen'
                            type='button'
                            role='tab'
                            aria-controls='nav-preview-on-unlocked-screen'
                            aria-selected='true'
                          >
                            <KTSVG path='/media/icons/duotune/locked/unlocked.svg' />
                            <span className='text'>In Message</span>
                          </button>
                          <button
                            className='nav-link rounded-start-0'
                            id='nav-preview-on-locked'
                            data-bs-toggle='tab'
                            data-bs-target='#nav-preview-on-locked-screen'
                            type='button'
                            role='tab'
                            aria-controls='nav-preview-on-locked-screen'
                            aria-selected='false'
                          >
                            <KTSVG path='/media/icons/duotune/locked/locked.svg' />
                            <span className='text'>Lockscreen</span>
                          </button>
                        </div>
                      </nav>
                      <div className='tab-content' id='nav-tabContent'>
                        <div
                          className='active fade show tab-pane'
                          id='nav-preview-on-unlocked-screen'
                          role='tabpanel'
                          aria-labelledby='nav-preview-on-unlocked-screen'
                        >
                          <div
                            className='active fade show tab-pane'
                            id='nav-preview-on-unlocked-screen'
                            role='tabpanel'
                            aria-labelledby='nav-preview-on-unlocked-screen'
                          >
                            <div
                              className='grey-bg mobile-bg-wrapper new_mobile'
                              style={{
                                backgroundImage: `url(${toAbsoluteUrl(
                                  '/media/mobile/NewMobile.png'
                                )})`,
                              }}
                            >
                              <div className='mobile-inner'>
                                <div className='mobile-head'>
                                  <strong
                                    className='d-block p-6 text-center msg-mobile-title px-12'
                                    data-testid='txtPreviewSenderID'
                                  >
                                    <KTSVG
                                      className='svg-icon-8'
                                      path='/media/icons/duotune/arrows/mobile_left_arrow.svg'
                                    />{' '}
                                    {sendData?.sender || 'Sender ID'}
                                  </strong>
                                </div>
                                <div className='mobile-body'>
                                  <div className='message-box' data-testid='previewMessageBox'>
                                    <div className='text-center time'>
                                      Today {moment().format('LT')}
                                    </div>
                                    {!quickSms && (
                                      <div className='fw-bolder message'>
                                        {sendData.subject || 'Engaging subject here'}
                                      </div>
                                    )}
                                    {!quickSms &&
                                      sendData?.media !== '' &&
                                      sendData?.media !== undefined && (
                                        <>
                                          {isEmpty(sendData?.media) &&
                                            typeof sendData?.media == 'string' && (
                                              <span>
                                                {!sendData?.mediaType
                                                  ?.split('/')
                                                  ?.includes('video') ? (
                                                  <img
                                                    src={sendData?.media}
                                                    alt='poster'
                                                    className='rounded-3 mb-2'
                                                  />
                                                ) : (
                                                  <video
                                                    src={sendData?.media}
                                                    width={300}
                                                    height={100}
                                                    controls
                                                  />
                                                )}
                                              </span>
                                            )}

                                          {isEmpty(sendData?.media) &&
                                            typeof sendData?.media !== 'string' &&
                                            !sendData?.media?.type?.includes('vcard') && (
                                              <span>
                                                {!sendData?.media?.type
                                                  ?.split('/')
                                                  ?.includes('video') ? (
                                                  <img
                                                    src={URL.createObjectURL(sendData?.media)}
                                                    alt='poster'
                                                    className='rounded-3 mb-2'
                                                  />
                                                ) : (
                                                  <video
                                                    src={URL.createObjectURL(sendData?.media)}
                                                    width={300}
                                                    height={100}
                                                    controls
                                                  />
                                                )}
                                              </span>
                                            )}

                                          {isEmpty(sendData?.media) &&
                                            typeof sendData?.media !== 'string' &&
                                            sendData?.media?.type?.includes('vcard') && (
                                              <span>
                                                <VCardPreview file={sendData.media} />
                                              </span>
                                            )}
                                        </>
                                      )}
                                    {!quickSms ? (
                                      sendData?.gif !== '' && sendData?.gif !== undefined ? (
                                        <span>
                                          <img
                                            src={sendData?.gif}
                                            alt='poster'
                                            className='rounded-3 mb-2'
                                          />
                                        </span>
                                      ) : !sendData?.media ? (
                                        <span>
                                          <img
                                            src='media/gif/default_mms_gif.gif'
                                            alt='poster'
                                            className='rounded-3 mb-2'
                                          />
                                        </span>
                                      ) : null
                                    ) : null}

                                    <div className='message'>
                                      <pre>{`${
                                        removeOptOutOrReply(sendData?.message) ||
                                        `1. 'Insert field' to add client name
2. Smartlink to track clicks
3. Sign-off with your name & contact
4. 'stoptxt' opt-out survey

${renderOptOutText()}`
                                      }`}</pre>
                                      {renderOptOutTextMessage()}
                                    </div>
                                  </div>
                                  <div className='send-msg'>
                                    <input type='text' />
                                    <a
                                      href='#'
                                      className='send_btn'
                                      style={{
                                        backgroundImage: `url(${toAbsoluteUrl(
                                          '/media/mobile/send.svg'
                                        )})`,
                                      }}
                                    ></a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className='fade tab-pane'
                          id='nav-preview-on-locked-screen'
                          role='tabpanel'
                          aria-labelledby='nav-preview-on-locked-screen'
                        >
                          <div
                            className='grey-bg mobile-bg-wrapper new_mobile'
                            style={{
                              backgroundImage: `url(${toAbsoluteUrl(
                                '/media/mobile/unlock-screen.svg'
                              )})`,
                            }}
                          >
                            <div className='unlock-screen-content'>
                              <div className='notification-outer'>
                                <div className='Notification-item'>
                                  <div className='user-icon'>
                                    <img
                                      alt='Logo'
                                      src={toAbsoluteUrl(
                                        '/media/mobile/user-icon-notification.png'
                                      )}
                                    />
                                  </div>
                                  <div
                                    className='notification-data'
                                    style={{
                                      width: '100%',
                                    }}
                                  >
                                    <label htmlFor='' data-testid='txtPreviewSenderID'>
                                      &#x2329;{' '}
                                      {sendData?.sender === '#SharedNum#'
                                        ? '#SharedNum#'
                                        : sendData?.sender || 'Sender ID'}
                                      &#12297;
                                    </label>
                                    <div
                                      className='nofication-detail-box'
                                      data-testid='notifMessageBox'
                                    >
                                      <p>{sendData?.message || 'Engaging message here'}</p>
                                      {!quickSms &&
                                        sendData?.media !== '' &&
                                        sendData?.media !== undefined && (
                                          <>
                                            {isEmpty(sendData?.media) &&
                                              typeof sendData?.media == 'string' && (
                                                <span>
                                                  {!sendData?.mediaType
                                                    ?.split('/')
                                                    ?.includes('video') ? (
                                                    <img
                                                      src={sendData?.media}
                                                      alt='poster'
                                                      className='rounded-3 mb-2'
                                                      style={{
                                                        width: '30px',
                                                        height: '30px',
                                                      }}
                                                    />
                                                  ) : null}
                                                </span>
                                              )}
                                            {isEmpty(sendData?.media) &&
                                              typeof sendData?.media !== 'string' && (
                                                <span>
                                                  {!sendData?.media?.type
                                                    ?.split('/')
                                                    ?.includes('video') ? (
                                                    <img
                                                      src={URL.createObjectURL(sendData?.media)}
                                                      alt='poster'
                                                      className='rounded-3 mb-2'
                                                      style={{
                                                        width: '30px',
                                                        height: '30px',
                                                      }}
                                                    />
                                                  ) : null}
                                                </span>
                                              )}
                                          </>
                                        )}
                                      {!quickSms ? (
                                        sendData?.gif !== '' && sendData?.gif !== undefined ? (
                                          <span>
                                            <img
                                              src={sendData?.gif}
                                              alt='poster'
                                              className='rounded-3 mb-2'
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                              }}
                                            />
                                          </span>
                                        ) : !sendData?.media ? (
                                          <span>
                                            <img
                                              src='media/gif/default_mms_gif.gif'
                                              alt='poster'
                                              className='rounded-3 mb-2'
                                              style={{
                                                width: '30px',
                                                height: '30px',
                                              }}
                                            />
                                          </span>
                                        ) : null
                                      ) : null}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </React.Fragment>
  )
}

export default QuickMessageDrawerInner
